import React, { Component } from 'react'
import { Grid } from 'semantic-ui-react'
import LandingPC from './pages/Landing/LandingPC'
import HomePC from './pages/Home/HomePC'
import SetupPC from './pages/Setup/SetupPC'
import StudentsPC from './pages/Students/StudentsPC'
import StudentPC from './pages/Student/StudentPC'
import TeachersPC from './pages/Teachers/TeachersPC'
import TeacherPC from './pages/Teacher/TeacherPC'
import SchoolYearsPC from './pages/SchoolYears/SchoolYearsPC'
import SubjectsPC from './pages/Subjects/SubjectsPC'
import ClubsPC from './pages/Clubs/ClubsPC'
import SectionsPC from './pages/Sections/SectionsPC'
import ClassesPC from './pages/Classes/ClassesPC'
import GradesPC from './pages/Grades/GradesPC'
import ConductsPC from './pages/Conducts/ConductsPC'
import AttendancesPC from './pages/Attendances/AttendancesPC'
import ClassConductsPC from './pages/ClassConducts/ClassConductsPC'
import ClassRemarksPC from './pages/ClassRemarks/ClassRemarksPC'
import FacsimilePC from './pages/Facsimile/FacsimilePC'
import FacsimileDetailsPC from './pages/Facsimile/FacsimileDetailsPC'
import PacePC from './pages/Pace/PacePC'
import PacePrintPC from './pages/Pace/PacePrintPC'
import NavBarC from './components/NavBar/NavBarC'
import FooterC from './components/Footer/FooterC'

import EnrollmentPC from './pages/Enrollment/EnrollmentPC'
import ApplicantsPC from './pages/Applicants/ApplicantsPC'
import PaymentsPC from './pages/Payments/PaymentsPC'
import EnrollmentFormPC from './pages/EnrollmentForm/EnrollmentFormPC'
import ApplicationTrackerPC from './pages/ApplicationTracker/ApplicationTrackerPC'

import './App.css'

import {
  BrowserRouter,
  Route,
  Switch
} from 'react-router-dom'

class App extends Component {
  constructor(props) {
    super(props);
    this.state = {
      title: 'Home'
    }
    this.handleContentUpdate = this.handleContentUpdate.bind(this);
  }

  handleContentUpdate(params) {
    this.setState({ title: params.title });
  }

  render() {
    return (
      <BrowserRouter>
        <NavBarC title={this.state.title}/>
          <Switch>
            <Route exact path="/" component={LandingPC} />
            <Route path="/welcome" component={LandingPC} />
            <Route path="/enrollment" component={EnrollmentPC} />
            <Route path="/enrollment-form" component={EnrollmentFormPC} />
            <Route path="/application-tracker" component={ApplicationTrackerPC} />
              <React.Fragment >
                <div className='main-content'>
                  <Grid centered>
                    <Grid.Column className='content-area'widescreen={10} computer={14} mobile={16}>
                      <Route exact path="/applicants"
                        render={props => <ApplicantsPC {...props} onContentMount={this.handleContentUpdate} />}
                      />
                      <Route exact path="/payments"
                        render={props => <PaymentsPC {...props} onContentMount={this.handleContentUpdate} />}
                      />
                      <Route exact path="/home"
                        render={props => <HomePC {...props} onContentMount={this.handleContentUpdate} />}
                      />
                      <Route exact path="/setup"
                        render={props => <SetupPC {...props} onContentMount={this.handleContentUpdate} />}
                      />
                      <Route exact path="/students"
                        render={props => <StudentsPC {...props} onContentMount={this.handleContentUpdate} />}
                      />
                      <Route exact path="/students/:id"
                        render={props => <StudentPC {...props} onContentMount={this.handleContentUpdate} />}
                      />
                      <Route exact path="/teachers"
                        render={props => <TeachersPC {...props} onContentMount={this.handleContentUpdate} />}
                      />
                      <Route exact path="/teachers/:id"
                        render={props => <TeacherPC {...props} onContentMount={this.handleContentUpdate} />}
                      />
                      <Route exact path="/school-years"
                        render={props => <SchoolYearsPC {...props} onContentMount={this.handleContentUpdate} />}
                      />
                      <Route exact path="/clubs"
                        render={props => <ClubsPC {...props} onContentMount={this.handleContentUpdate} />}
                      />
                      <Route exact path="/subjects"
                        render={props => <SubjectsPC {...props} onContentMount={this.handleContentUpdate} />}
                      />
                      <Route exact path="/sections"
                        render={props => <SectionsPC {...props} onContentMount={this.handleContentUpdate} />}
                      />
                      <Route exact path="/classes"
                        render={props => <ClassesPC {...props} onContentMount={this.handleContentUpdate} />}
                      />
                      <Route exact path="/classes/:sectionId"
                        render={props => <ClassesPC {...props} onContentMount={this.handleContentUpdate} />}
                      />
                      <Route exact path="/facsimile"
                        render={props => <FacsimilePC {...props} onContentMount={this.handleContentUpdate} />}
                      />
                      <Route exact path="/facsimile/:sectionId/:studentId/:schoolYearId"
                        render={props => <FacsimileDetailsPC {...props} onContentMount={this.handleContentUpdate} />}
                      />
                      <Route exact path="/grades/:sectionId/:sectionSubjectId"
                        render={props => <GradesPC {...props} onContentMount={this.handleContentUpdate} />}
                      />
                      <Route exact path="/pace/print/:sectionStudentId"
                        render={props => <PacePrintPC {...props} onContentMount={this.handleContentUpdate} />}
                      />
                      <Route exact path="/pace/:sectionId([0-9a-fA-F-]{36})/:sectionSubjectId"
                        render={props => <PacePC {...props} onContentMount={this.handleContentUpdate} />}
                      />
                      <Route exact path="/conducts/:sectionId/:sectionSubjectId"
                        render={props => <ConductsPC {...props} onContentMount={this.handleContentUpdate} />}
                      />
                      <Route exact path="/attendances/:schoolYearId/:sectionId"
                        render={props => <AttendancesPC {...props} onContentMount={this.handleContentUpdate} />}
                      />
                      <Route exact path="/classconducts/:sectionId"
                        render={props => <ClassConductsPC {...props} onContentMount={this.handleContentUpdate} />}
                      />
                      <Route exact path="/remarks/:sectionId"
                        render={props => <ClassRemarksPC {...props} onContentMount={this.handleContentUpdate} />}
                      />
                  </Grid.Column>
                </Grid>
              </div>
              </React.Fragment>
          </Switch>

        <FooterC />
      </BrowserRouter>
    );
  }
}

export default App;
